"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenHandler = void 0;
const tokenHandler = (providedToken) => {
    let tokenString;
    let callbacks = [];
    const token = {
        set: (t) => {
            tokenString = t;
        },
        get: () => {
            return tokenString || providedToken || '';
        },
        addEventListener: (callback) => {
            callbacks.push(callback);
        },
        removeEventListener: (callback) => {
            callbacks = callbacks.filter((c) => c !== callback);
        },
    };
    return token;
};
exports.tokenHandler = tokenHandler;
//# sourceMappingURL=token.js.map